import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-new-header',
  template: '',
  styles: []
})
export class NewHeaderComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
  getCount() { }
}
